import { findRecursive } from '@/mm/utils.js'

export function washData_relatedCarouselProduct(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'text_title',
    'list'
  )
  if (walkedNode._type === 'related_carousel_product1') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  } else if (walkedNode._type === 'related_carousel_product2') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_product3') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  } else if (walkedNode._type === 'related_carousel_product4') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  }
}
